export const INITIAL_TABS = 'INITIAL_TABS';
export const UDATE_ACTIVE_TAB = 'UDATE_ACTIVE_TAB';
